export const formatAreaCode = (areaCode: string) => {
  if (areaCode.includes('_')) return areaCode.split('_')[1]
  if (areaCode.includes('+')) return areaCode.replace('+', '00')
}
